export const HIDDEN_INPUTS = {
  tab: 'tab',
  searchOption: 'searchOption'
};
